import type { Profile } from '@/entities/Profile';
import type { OnboardingAwareCenter } from './types';

export type OnboardingFlowStage =
  | 'center-onboarding'
  | 'dashboard-tour'
  | 'script-setup'
  | 'checklist-guide'
  | 'live-setup-tour'
  | 'complete';

interface ResolveOnboardingFlowStageInput {
  role: string | null;
  profile: Profile | null;
  center: OnboardingAwareCenter | null;
}

export const resolveOnboardingFlowStage = ({
  role,
  profile,
  center: _center,
}: ResolveOnboardingFlowStageInput): OnboardingFlowStage => {
  if (profile?.onboarding_flow_completed_at) {
    return 'complete';
  }

  if (role === 'representative') {
    if (!profile?.dashboard_tour_completed_at) {
      return 'dashboard-tour';
    }

    if (!profile?.checklist_guide_completed_at) {
      return 'checklist-guide';
    }

    if (!profile?.live_setup_tour_completed_at) {
      return 'live-setup-tour';
    }

    return 'complete';
  }

  if (role !== 'center_manager') {
    return 'complete';
  }

  if (!profile?.center_onboarding_completed_at) {
    return 'center-onboarding';
  }

  if (!profile?.dashboard_tour_completed_at) {
    return 'dashboard-tour';
  }

  if (!profile?.script_setup_completed_at) {
    return 'script-setup';
  }

  if (!profile?.checklist_guide_completed_at) {
    return 'checklist-guide';
  }

  if (!profile?.live_setup_tour_completed_at) {
    return 'live-setup-tour';
  }

  return 'complete';
};
